import { useEffect, useState } from 'react'

export const useCollapsible = ({ collapsedOnMobile = true } = {}) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsedOnMobile)

  useEffect(() => {
    if (window?.innerWidth > 1024) {
      setIsCollapsed(false)
    }
  }, [])

  return { isCollapsed, setIsCollapsed }
}
